const topics = [
  { icon: 'ri-fire-line', label: '本周热播', desc: '全网最火影视合集', color: 'text-primary-500', bg: 'bg-primary-100' },
  { icon: 'ri-movie-2-line', label: '最新上映', desc: '院线大片抢先看', color: 'text-accent-600', bg: 'bg-accent-100' },
  { icon: 'ri-tv-2-line', label: '高分美剧', desc: 'IMDb 8分+精选', color: 'text-secondary-600', bg: 'bg-secondary-100' },
  { icon: 'ri-ancient-gate-line', label: '古装剧场', desc: '经典国风大制作', color: 'text-primary-500', bg: 'bg-primary-100' },
  { icon: 'ri-ghost-line', label: '悬疑惊悚', desc: '烧脑推理高能预警', color: 'text-accent-600', bg: 'bg-accent-100' },
  { icon: 'ri-rocket-2-line', label: '科幻巨制', desc: '硬核科幻视觉盛宴', color: 'text-secondary-600', bg: 'bg-secondary-100' },
  { icon: 'ri-emotion-laugh-line', label: '喜剧合辑', desc: '欢乐解压笑不停', color: 'text-primary-500', bg: 'bg-primary-100' },
  { icon: 'ri-heart-pulse-line', label: '韩剧热追', desc: '浪漫甜宠高分好剧', color: 'text-accent-600', bg: 'bg-accent-100' },
  { icon: 'ri-earth-line', label: '纪录万象', desc: 'BBC国家地理精选', color: 'text-secondary-600', bg: 'bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              主题索引
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              按题材快速找到您想看的影视内容，九大主题专区随心选
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
            {topics.map((topic, idx) => (
              <a
                key={idx}
                href="#media"
                className="group bg-background-50 rounded-xl p-5 md:p-6 flex flex-col items-center text-center gap-3 hover:-translate-y-1 transition-transform duration-200 cursor-pointer"
              >
                <div className={`w-14 h-14 rounded-2xl ${topic.bg} flex items-center justify-center`}>
                  <i className={`${topic.icon} ${topic.color} text-2xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1">
                    {topic.label}
                  </h3>
                  <p className="text-xs text-foreground-500">{topic.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}